import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface DashboardStatisticItem {
  slug: string
  label: string
  value: number | string | null
}

export function getDashboardStatisticsAction(): Promise<ApiResponse<DashboardStatisticItem[]>> {
  return api.get<ApiResponse<DashboardStatisticItem[]>>(`/statistics/dashboard`)
}
